export default {
  "site.name": "AllChinaBuy Spreadsheet",
  "site.title": "AllChinaBuy Spreadsheet - Produkter, Sælgere & Købsguider",
  "site.description": "Udforsk AllChinaBuy Spreadsheet-ressourcer, produktfund, sælgerforskning, QC-guides, forsendelsesinformation, lager-tips og praktiske købsguider — organiseret i et brugervenligt ressourcecenter.",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Kategorier",
  "nav.guides": "Guides",
  "nav.review": "Anmeldelse",
  "nav.shipping": "Forsendelse",
  "nav.qc": "QC",
  "nav.safety": "Sikkerhed",
  "nav.faq": "FAQ",
  "nav.home": "Forside",
  "nav.shoppingGuide": "Indkøbsguide",
  "hero.eyebrow": "ALLCHINABUY SPREADSHEET RESSOURCECENTER",
  "hero.title": "AllChinaBuy Spreadsheet — Find Produkter, Sælgere & Købsguider på Ét Sted",
  "hero.description": "Udforsk AllChinaBuy Spreadsheet-ressourcer, produktfund, sælgerforskning, QC-guides, forsendelsesinformation, lager-tips og praktiske købsguider — organiseret i et brugervenligt ressourcecenter.",
  "hero.cta1": "Udforsk AllChinaBuy Spreadsheet",
  "hero.cta2": "Køb Nu",
  "hero.trust": "Uafhængig Ressource · Regelmæssigt Opdateret · Flersproget · Sikkerhedsguides",
  "categories.title": "Produktkategorier",
  "categories.description": "Gennemse vores kuraterede produktkategorier og find præcis det, du har brug for på AllChinaBuy Spreadsheet.",
  "categories.select": "Vælg en Kategori",
  "articles.title": "AllChinaBuy Spreadsheet Guides",
  "articles.description": "Omfattende guides og ressourcer til at hjælpe dig med at navigere i AllChinaBuy Spreadsheet-oplevelsen.",
  "articles.readMore": "Læs Guiden",
  "cta.title": "Klar til at Handle?",
  "cta.description": "Besøg hovedsiden AllChinaBuy Spreadsheet for at udforske produkter, sammenligne priser og handle med tillid.",
  "cta.mainSite": "Besøg AllChinaBuy Spreadsheet",
  "cta.buyNow": "Køb Nu",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Kategorier",
  "footer.sellers": "Sælgere",
  "footer.guides": "Guides",
  "footer.review": "Anmeldelse",
  "footer.shipping": "Forsendelse",
  "footer.qc": "QC",
  "footer.warehouse": "Lager",
  "footer.safety": "Sikkerhed",
  "footer.resources": "Ressourcer",
  "footer.articles": "Artikler",
  "footer.faq": "FAQ",
  "footer.comparisons": "Sammenligninger",
  "footer.company": "Virksomhed",
  "footer.about": "Om Os",
  "footer.contact": "Kontakt",
  "footer.privacy": "Privatlivspolitik",
  "footer.terms": "Servicevilkår",
  "footer.disclaimer": "AllChinaBuySpread er en uafhængig informationsressource og ikke den officielle AllChinaBuy-hjemmeside.",
  "footer.language": "Sprog",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.da": "Dansk",
  "article.published": "Udgivet",
  "article.readTime": "min. læsetid",
  "article.backToHome": "Tilbage til Forsiden",
  "article.relatedArticles": "Relaterede Artikler",
  "article.tableOfContents": "Indholdsfortegnelse",
  "whatIs.title": "Hvad er AllChinaBuy Spreadsheet?",
  "whatIs.description": "AllChinaBuy Spreadsheet er et omfattende ressourcecenter designet til at hjælpe købere med at navigere i den komplekse verden af international køb. Vi kuraterer produktlister, sælgeranmeldelser, forsendelsesguides og kvalitetskontrolinformation for at gøre din købsoplevelse smidig og sikker.",
  "trust.title": "Hvorfor Stole på AllChinaBuy Spreadsheet?",
  "trust.item1": "Uafhængig ressource uden tilknytning til sælgere",
  "trust.item2": "Regelmæssigt opdaterede produktkategorier og priser",
  "trust.item3": "Flersproget support for globale købere",
  "trust.item4": "Omfattende sikkerheds- og QC-guides",
  "seo.article1.title": "AllChinaBuy Spreadsheet Komplet Guide",
  "seo.article1.desc": "En omfattende guide til brug af AllChinaBuy Spreadsheet til produktresearch, prissammenligning og søgning efter pålidelige sælgere.",
  "seo.article1.date": "August 2026",
  "seo.article1.readTime": "8",
};